import { render, staticRenderFns } from "./FirstTimeModal.vue?vue&type=template&id=7a0c8690&scoped=true&"
import script from "./FirstTimeModal.vue?vue&type=script&lang=js&"
export * from "./FirstTimeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c8690",
  null
  
)

export default component.exports